import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import CommonRoutes from "../Common/commonRoute";
import { EmployeePanelEmpSidebarData, EmpPanelSidebarData } from "../../Module/EmployeePanelSidebarData";
import Sidebar from "../../Module/sidebar";
import { Navigate, Route, useNavigate } from "react-router";
import MovementsOfMeeting from "./Movements of Meeting/movementsOfMeeting";
import EditMovementsOfMeeting from "./Movements of Meeting/editMovementsOfMeeting";
import { useDispatch } from "react-redux";
import { Logout, setInitialState } from "../../Action/authAction";
import { showSuccessSnackbar } from "../../Action/snackbarAction";

function EmployeeDashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginType, role, authToken } = useSelector((state) => ({
    designation: state.Auth?.userInfo?.designation,
    loginType: state.Auth?.loginType,
    role: state?.Auth?.userInfo?.role,
    authToken: state?.Auth?.authToken,
  }));

  useEffect(() => {
    if (!(role === "EMPLOYEE" && authToken)) {
      dispatch(setInitialState());
      navigate("/");
    }
  }, [role, dispatch, Navigate, authToken]);

  return (
    <div className="AppBox">
      <Sidebar data={loginType === 2 ? EmployeePanelEmpSidebarData : EmpPanelSidebarData} />
      <div className="dashboard">
        {
          <CommonRoutes loginType={loginType}>
            <Route path="movementsOfMeeting" element={<MovementsOfMeeting />} />
            <Route
              path="editMovementsOfMeeting"
              element={<EditMovementsOfMeeting />}
            />
          </CommonRoutes>
        }
      </div>
    </div>
  );
}

export default EmployeeDashboard;
